import { LetterBox, SelectionIndicator, Stat, Sup, TallCard, Text } from './statCard.styles'

interface StatCardTallProps {
  topText: string
  title: string
  speed: number
  accuracy: number
  color: string
}

export const StatCardTall = ({ speed, accuracy, title, topText, color }: StatCardTallProps) => {
  return (
    <TallCard onClick={() => ''}>
      <LetterBox color={color}>{topText}</LetterBox>
      <Text>{title}</Text>
      <Stat>
        {speed}
        <Sup>wpm</Sup>
      </Stat>
      <Text>Accuracy {accuracy}%</Text>
      <SelectionIndicator></SelectionIndicator>
    </TallCard>
  )
}
